import {downloadFromUrl} from "./General";

// TODO: Group it in an object to be imported as an object.

/**
 * Downloads all clients in an Excel.
 *
 * @param filters
 */
export function downloadClientsXLSX(filters = null) {
    downloadFromUrl('/api/excel/clients', filters, 'clientes');
}

/**
 * Downloads all entities in an Excel.
 *
 * @param filters
 */
export function downloadEntitiesXLSX(filters = null) {
    downloadFromUrl('/api/excel/entities', filters, 'entidades');
}

/**
 * Downloads all attorneys in an Excel.
 *
 * @param filters
 */
export function downloadAttorneysXLSX(filters = null) {
    downloadFromUrl('/api/excel/attorneys', filters, 'procuradores');
}

/**
 * Downloads all expedients as shown in the table.
 *
 * @param filters
 */
export function downloadExpedientsXLSX(filters = null) {
    downloadFromUrl('/api/excel/expedients', filters, 'expedientes');
}

/**
 * Downloads all lawyers in an Excel.
 *
 * @param filters
 */
export function downloadLawyersXLSX(filters = null) {
    downloadFromUrl('/api/excel/lawyers', filters, 'letrados');
}

/**
 * Downloads the specific excel for the administrator user.
 */
export function downloadSeguimientoExpedientesXLSX() {
    downloadFromUrl('/api/excel/seguimiento-expedientes', null, 'seguimiento-expedientes');
}

/**
 * Downloads all tasks as shown in the table.
 */
export function downloadTareasXLSX(filters = null) {
    downloadFromUrl('/api/excel/tasks', filters, 'tareas');
}
